import { connect } from 'react-redux';

import {
    addComment,
    showComment,
} from '../../actions/EditMod';

import EditComments from '../../components/Edit/EditComments/EditComments';
import DialogConfirmation from '../DialogConfirmation/DialogConfirmationWrapper';
import { openDialog } from '../../actions/Dialog';

const mapStateToProps = (state) => ({
    comments: state.editMod.comments,
    isErrorComments: state.editMod.isErrorComments,
    isFetchedComments: state.editMod.isFetchedComments,
})

const mapDispatchToProps = (dispatch) => ({
    onCommentAdd: (modId, content, type) => {
        dispatch(addComment(modId, content, type))
    },

    onClickRemoveComment: (commentId, modId, type) => {
        dispatch(openDialog(<DialogConfirmation id={commentId} modId={modId} isCommentMode={true} type={type} />))
    },

    onClickHideComment: (commentId, modId, type) => {
        dispatch(openDialog(<DialogConfirmation id={commentId} modId={modId} isCommentMode={true} type={type} isHide={true} />))
    },

    onClickShowComment: (commentId, modId, type) => {
        dispatch(showComment(commentId, modId, type))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(EditComments)

